import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { resetConfig, startRequest as getConfig } from './redux/actions';
import { isLoadingSelect } from './redux/selectors';
import Loading from 'components/Loading';

export const ConfigWrapper = (props) => {
  const { children } = props;
  const dispatch = useDispatch();
  const isLoading = useSelector(isLoadingSelect);
  useEffect(() => {
    dispatch(getConfig());
    return () => {
      dispatch(resetConfig());
    };
  }, []);

  return (
    <>
      {isLoading ? (
        <div className="main-page_bg">
          <Loading />
        </div>
      ) : (
        children
      )}
    </>
  );
};

ConfigWrapper.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};
